import imageServices from '../../services/image';
import Image from '../../model/image';

export const state = {
    images: [],
    image: {},
}

export const mutations = {
    setImage(state, image) {
        state.image = image
    },
    setImages(state, images) {
        state.images = images
    },
    addImage(state, image) {
        state.images = [image, ...state.images]
    },
}

export const getters = {
    getImage(state) {
        return new Image(state.image);
    },
    getImages(state) {
        return state.images.map((p)=>new Image(p))
    },
}

export const actions = {
    get({commit}, id){
        return imageServices.get(id)
        .then((response)=>{
            commit('setImage', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return imageServices.getAll(data)
        .then((response)=>{
            commit('setImages', response.data.data)
            return response
        })
    },
    add({commit}, post){
        return imageServices.add(post)
        .then((response)=>{
            commit('addImage', response.data.data)
            return response
        })
    },
    edit({commit, state}, {id, image}){
        return imageServices.edit(id, image)
        .then((response)=>{
            commit('setImages', (state.images[state.images.findIndex((x)=>x.id == id)] = response.data))
            return response
        })
    },
    delete({commit}, id){
        return imageServices.delete(id)
        .then((response)=>{
            commit('setImages', (state.images.filter((x)=>x.id != id)))
            return response
        })
    },
}